import { apiClient, APIResponse, authStorage, extractApiError } from './api';

/**
 * Notification preferences API (transactional + marketing).
 */
export const notificationsAPI = {
  async getPreferences() {
    try {
      const { data } = await apiClient.get('/me/');
      return APIResponse.success(data?.profile ?? {});
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar preferências.'));
    }
  },

  async updatePreferences(fields) {
    try {
      const { data } = await apiClient.patch('/me/', fields);
      authStorage.write({ user: data });
      return APIResponse.success(data?.profile ?? {});
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível guardar preferências.'));
    }
  },

  async marketingOptIn(source = 'settings') {
    try {
      const { data } = await apiClient.post('/me/marketing-opt-in/', { source });
      authStorage.write({ user: data });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível activar emails de marketing.'));
    }
  },

  async marketingOptOut() {
    try {
      const { data } = await apiClient.post('/me/marketing-opt-out/');
      authStorage.write({ user: data });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível cancelar emails de marketing.'));
    }
  },
};

async function notificationsLoader() {
  const res = await notificationsAPI.getPreferences();
  if (!res.success) {
    throw new Response(res.error, { status: 500 });
  }
  return res.data;
}

notificationsLoader.displayName = 'notificationsLoader';

export { notificationsLoader };
